import BaseService from "../BaseService";

class PricingService extends BaseService {
    getSetting = async () => {
        return await this._api.post("/pricing/getsetting", {});
    };

    saveSetting = async ({ enabled }) => {
        return await this._api.post("/pricing/savesetting", { enabled });
    };

    list = async () => {
        return await this._api.post("/pricing/getlist", {});
    };

    getByID = async (id) => {
        return await this._api.post("/pricing/getbyid", { id });
    };

    create = async (data) => {
        return await this._api.post("/pricing/create", data);
    };

    update = async (data) => {
        return await this._api.post("/pricing/update", data);
    };

    delete = async (id) => {
        return await this._api.post("/pricing/delete", { id });
    };

    getPriceItems = async (id) => {
        return await this._api.post("/pricing/getpriceitems", { id });
    };

    savePriceItems = async ({ id, items }) => {
        return await this._api.post("/pricing/savepriceitems", { id, items });
    };

    getCustomers = async (id) => {
        return await this._api.post("/pricing/getcustomers", { id });
    };

    setCustomerPriceTable = async ({ customer_id, price_table_id }) => {
        return await this._api.post("/pricing/setcustomerpricetable", { customer_id, price_table_id });
    };
}

export default PricingService;
